import React from "react";
import { Form, Row, Col } from "react-bootstrap";
import Select from "react-select";
import InputError from "../../InputError/InputError";

import "./Forms.css";

function SelectField({
  required,
  type,
  formLabel,
  size,
  options,
  searchable,
  name,
  value,
  onChange,
  isError,
  errorMessage = "",
  className,
  disabled,
  placeholder,
  showPlaceholder = false,
}) {
  return (
    <Form>
      {type === "inline" ? (
        <Form.Group className="mb-3" controlId="formBasicEmail">
          <Row>
            <Col sm={4}>
              <Form.Label className="form-label align-left">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
            </Col>
            <Col sm={6}>
              {searchable ? (
                <Select
                  value={value}
                  options={options}
                  name={name}
                  size={size}
                  onChange={onChange}
                  // placeholder="hsjfhjd"
                  // placeholder={name}
                  disabled={disabled}
                />
              ) : (
                <Form.Select
                  className={className}
                  size={size}
                  name={name}
                  value={value}
                  onChange={onChange}
                  placeholder={name}
                  disabled={disabled}
                >
                  {showPlaceholder && (
                    <option value="" hidden={required} disabled={required}>
                      {placeholder || "SELECT"}
                    </option>
                  )}
                  {options.map((data) => {
                    if (
                      data.label !== "SELECT" &&
                      data.label !== "Select" &&
                      data.label !== "Edit Schedule"
                    ) {
                      return <option value={data.value}>{data.label}</option>;
                    } else {
                      return (
                        <option value="" hidden selected>
                          {data.label}
                        </option>
                      );
                    }
                  })}
                </Form.Select>
              )}
              <InputError
                isValid={isError}
                message={errorMessage !== "" ? errorMessage : "*Required"}
              />
            </Col>
          </Row>
        </Form.Group>
      ) : (
        <>
          {searchable ? (
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="align-left form-label">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
              <Select
                value={value}
                options={options}
                name={name}
                size={size}
                onChange={onChange}
                // placeholder={name}
                disabled={disabled}
              />
              <InputError
                isValid={isError}
                message={errorMessage !== "" ? errorMessage : "*Required"}
              />
            </Form.Group>
          ) : (
            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label className="align-left form-label">
                {formLabel}
                {required && <span className="badge">*</span>}
              </Form.Label>
              <Form.Select
                className={className}
                size={size}
                name={name}
                value={value}
                onChange={onChange}
                placeholder={name}
                disabled={disabled}
              >
                {showPlaceholder && (
                  <option value="" hidden={required} disabled={required}>
                    {placeholder || "SELECT"}
                  </option>
                )}
                {options?.map((data) => {
                  if (
                    data.label !== "SELECT" &&
                    data.label !== "Select" &&
                    data.label !== "Edit Schedule"
                  ) {
                    return <option value={data.value}>{data.label}</option>;
                  } else {
                    return (
                      <option value="" hidden selected>
                        {data.label}
                      </option>
                    );
                  }
                })}
              </Form.Select>
              <InputError
                isValid={isError}
                message={errorMessage !== "" ? errorMessage : "*Required"}
              />
            </Form.Group>
          )}
        </>
      )}
    </Form>
  );
}

export default SelectField;
